import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { ErrorResponse, Response } from '@/types';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import {
  SelfInitiatedProfile,
  AdminInitiatedProfile,
} from '@/features/setup/types';

type PayloadType = SelfInitiatedProfile | AdminInitiatedProfile;

export const postUserProfile = async (
  payload: PayloadType
): Promise<Response> => {
  return axios.post('/api/v1/profiles', payload);
};

type QueryFnType = typeof postUserProfile;

type Options = {
  config?: MutationConfig<QueryFnType>;
};

export const usePostUserProfile = ({ config }: Options = {}) => {
  return useMutation({
    ...config,
    mutationFn: (args) => postUserProfile(args),
    onError: (error: AxiosError<ErrorResponse>) => {
      return error.response?.data;
    },
  });
};
